import { AppEnv } from './env-types';
import { merge } from 'lodash';
import { npdEnvDefaults } from './env-defaults';

window.MLBBest = {
  env: merge(npdEnvDefaults, {
    appEnv: AppEnv.STG,
    piaApiBaseUrl: 'https://pia-stg.best-gcp-npd.mlbinfra.com',
  }),
};
